import type { RunCommandActivityNode, RunStageActivityNode } from '../types';

const GROUPED_RUN_DETAIL_STAGES = new Set(['thinking', 'actions', 'updates']);

export const normalizeActivityStageGroupId = (stage: string): string => {
  const normalized = stage.trim().toLowerCase();
  if (!normalized || GROUPED_RUN_DETAIL_STAGES.has(normalized)) {
    return 'run';
  }
  return normalized;
};

export const groupCommandsByHighLevelStage = (
  commands: RunCommandActivityNode[],
  stageLabelForId: (stageId: string, fallbackName: string) => string
): RunStageActivityNode[] => {
  const stageMap = new Map<
    string,
    {
      id: string;
      name: string;
      latest_event_id: number;
      first_event_id: number;
      commands: RunCommandActivityNode[];
    }
  >();

  for (const command of commands) {
    const stageId = normalizeActivityStageGroupId(command.stage);
    const existing = stageMap.get(stageId) ?? {
      id: stageId,
      name: stageLabelForId(stageId, stageId),
      latest_event_id: command.latest_event_id,
      first_event_id: command.latest_event_id,
      commands: []
    };
    existing.latest_event_id = Math.max(existing.latest_event_id, command.latest_event_id);
    existing.first_event_id = Math.min(existing.first_event_id, command.latest_event_id);
    existing.commands.push(command);
    stageMap.set(stageId, existing);
  }

  return Array.from(stageMap.values())
    .sort((a, b) => a.first_event_id - b.first_event_id)
    .map((stage) => ({
      id: stage.id,
      name: stage.name,
      latest_event_id: stage.latest_event_id,
      commands: stage.commands.sort((a, b) => a.latest_event_id - b.latest_event_id)
    }));
};
